import { getJSON } from "../../../../http";
import { SubscriptionItem } from "../../../types";
import { subscriptionItemFromDTO } from "../../utils";
import { subscriptionUrlSubscriptionManagement } from "./subscriptionItems.constants";
import type { SubscriptionItemsResponse } from "./subscriptionItems.types";

export const fetchSubscriptionItems = async (): Promise<SubscriptionItem[]> => {
  const subscriptionItemsResponse = await getJSON<SubscriptionItemsResponse>(`${subscriptionUrlSubscriptionManagement}`);

  const subscriptionItems = subscriptionItemsResponse.map<SubscriptionItem>(subscriptionItemFromDTO);

  return subscriptionItems.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
};
